// extracted by mini-css-extract-plugin
export default {"card":"x1-z","carouselContainer":"y1-z","carouselContent":"z1-z"};